import { RunStateTransition } from "types/generated";

import ReadyEntry from "../entries/ReadyEntry";
import { canShowElement } from "./elements";
import { RunElementType, RunEntryContext } from "../types";
import { getRunStateTransitionId } from "./getRunStateTransitionId";

export const createReadyEntry = (
  { timestamp, until, stateVersion }: RunStateTransition,
  { isSimpleView, canDiscard, stackId, runId, runQueryToRefetch }: RunEntryContext
) => {
  // We can hide the ready entry if it's finished and we're in simple view.
  if (isSimpleView && until) {
    return null;
  }

  return (
    <ReadyEntry
      key={getRunStateTransitionId(timestamp, stateVersion)}
      timestamp={timestamp}
      until={until}
      showDiscardButton={canShowElement(RunElementType.TerminateRunAction)}
      canDiscard={canDiscard}
      stackId={stackId}
      runId={runId}
      runQueryToRefetch={runQueryToRefetch}
    />
  );
};
